import { FC, useMemo, useState } from 'react'

import { JoonAdminCountryCard } from './JoonAdminCountryCard'
import { CreateCountryModal } from './CreateCountryModal/CreateCountryModal'
import { FeeScheduleModal, FeeScheduleTarget } from './FeeScheduleModal/FeeScheduleModal'
import { StyledButton } from 'Components/Buttons/StyledButton'

import { useEmployerInfoContext } from 'Contexts/EmployerInfoContext'
import { GridContainer } from '../BenefitPrograms/JoonAdminBenefitProgramsGrid'
import { FlexColumn, FlexRow, spacingSM } from 'Utils/styles/spacing'
import { TableLabel } from 'Utils/styles/text'
import { FeeSchedule } from 'Utils/types/employerInfo'
import { CountryCode } from 'Utils/types/countries'

export const JoonAdminCountriesGrid: FC = () => {
  const {
    state: { employerInfo }
  } = useEmployerInfoContext()

  const [showCreateCountryModal, setShowCreateCountryModal] = useState(false)

  const [showFeeScheduleModal, setShowFeeScheduleModal] = useState(false)
  const [feeScheduleTarget, setFeeScheduleTarget] = useState<FeeScheduleTarget | null>(null)
  const openFeeScheduleModal = (countryCode: CountryCode, feeSchedule: FeeSchedule | null) => {
    setFeeScheduleTarget({ countryCode, feeSchedule })
    setShowFeeScheduleModal(true)
  }
  const setShowFeeSchedule = (value: boolean) => {
    setShowFeeScheduleModal(value)
    if (!value) {
      setFeeScheduleTarget(null)
    }
  }

  const countryConfigs = useMemo(() => {
    const configs = employerInfo?.countryConfigs

    return configs ? Object.values(configs) : null
  }, [employerInfo?.countryConfigs])

  if (!countryConfigs) return null

  return (
    <>
      <FlexColumn gap={spacingSM}>
        <FlexRow style={{ justifyContent: 'space-between' }}>
          <TableLabel>Countries</TableLabel>
          <StyledButton
            id="createEmployerCountry.button.label"
            primary
            onClick={() => setShowCreateCountryModal(true)}
          />
        </FlexRow>
        <GridContainer>
          {countryConfigs.map((countryConfig) => (
            <JoonAdminCountryCard
              key={`country_config_${countryConfig.id}`}
              countryConfig={countryConfig}
              onOpenFeeScheduleModal={openFeeScheduleModal}
            />
          ))}
        </GridContainer>
      </FlexColumn>
      <CreateCountryModal
        showModal={showCreateCountryModal}
        setShowModal={setShowCreateCountryModal}
      />
      <FeeScheduleModal
        showModal={showFeeScheduleModal}
        setShowModal={setShowFeeSchedule}
        target={feeScheduleTarget}
      />
    </>
  )
}
